import { render } from "./App.vue?vue&type=template&id=c862dc0e"
const script = {}
script.render = render

export default script